/* Dynacore Navbar — dynacore-navbar.js */
(function () {
  'use strict';

  /* ── Fix overflow:hidden on all ancestors so dropdowns aren't clipped ── */
  function fixAncestorOverflow() {
    var el = document.getElementById('dn-wrap');
    while (el && el !== document.documentElement) {
      var cs = window.getComputedStyle(el);
      if (cs.overflow === 'hidden' || cs.overflowX === 'hidden' ||
          cs.overflow === 'clip'   || cs.overflowX === 'clip') {
        el.style.setProperty('overflow',   'visible', 'important');
        el.style.setProperty('overflow-x', 'visible', 'important');
      }
      el = el.parentElement;
    }
  }

  /* Run immediately and again after a short delay (theme JS may re-set it) */
  fixAncestorOverflow();
  setTimeout(fixAncestorOverflow, 300);

  /* ── Nav dropdowns ─────────────────────────────────────────────────── */
  var DROPDOWNS = ['dn-ni-categories', 'dn-ni-parts', 'dn-ni-enterprise'];
  var backdrop  = document.getElementById('dn-backdrop');
  var navbar    = document.getElementById('dn-navbar');
  var current   = null;
  var timer     = null;

  function openNav(id) {
    clearTimeout(timer);
    var el = document.getElementById(id);
    if (!el) return;
    if (current && current !== el) closeNav(true);
    el.classList.add('open');
    var btn = el.querySelector('.dn-btn');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (backdrop) backdrop.classList.add('on');
    if (navbar)   navbar.classList.add('open');
    current = el;
  }

  function closeNav(immediate) {
    clearTimeout(timer);
    function doClose() {
      if (!current) return;
      current.classList.remove('open');
      var btn = current.querySelector('.dn-btn');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (backdrop) backdrop.classList.remove('on');
      if (navbar)   navbar.classList.remove('open');
      current = null;
    }
    if (immediate) { doClose(); } else { timer = setTimeout(doClose, 110); }
  }

  DROPDOWNS.forEach(function (id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('mouseenter', function () { openNav(id); });
    el.addEventListener('mouseleave', function () { closeNav(false); });
  });

  if (backdrop) backdrop.addEventListener('click', function () { closeNav(true); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(); closeNav(true); }
  });

  /* ── Search overlay ─────────────────────────────────────────────────── */
  var searchOverlay  = document.getElementById('dn-search-overlay');
  var searchInput    = document.getElementById('dn-search-input');
  var searchClear    = document.getElementById('dn-search-clear');
  var searchBtn      = document.getElementById('dn-search-btn');
  var searchResults  = document.getElementById('dn-search-results');
  var searchDefault  = document.getElementById('dn-search-default');
  var searchDebounce = null;
  var lastQuery      = '';

  function openSearch() {
    closeNav(true);
    if (!searchOverlay) return;
    searchOverlay.classList.add('on');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 180);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('on');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    if (searchClear) searchClear.classList.remove('visible');
    showDefaultContent();
  }

  /* ── Live search helpers ─────────────────────────────────────────────── */
  function showDefaultContent() {
    if (searchResults) { searchResults.style.display = 'none'; searchResults.innerHTML = ''; }
    if (searchDefault) searchDefault.style.display = '';
    lastQuery = '';
  }

  function showResultsContent() {
    if (searchDefault) searchDefault.style.display = 'none';
    if (searchResults) searchResults.style.display = 'block';
  }

  function formatPrice(val) {
    return '$' + parseFloat(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function esc(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s));
    return d.innerHTML;
  }

  function renderResults(items, query) {
    if (!searchResults) return;
    if (!items || items.length === 0) {
      searchResults.innerHTML =
        '<p class="dn-search-no-results">No results for &ldquo;' +
        esc(query) + '&rdquo;</p>';
      return;
    }
    var html = '';
    for (var i = 0; i < items.length; i++) {
      var p     = items[i];
      var img   = (p.featured_image && p.featured_image.url) ? p.featured_image.url : '';
      var title = esc(p.title || '');
      var price = (p.price) ? formatPrice(p.price) : '';
      var url   = esc(p.url || ('/products/' + (p.handle || '')));
      html += '<a class="dn-result-item" href="' + url + '">';
      if (img) {
        html += '<img class="dn-result-img" src="' + esc(img) + '" alt="' + title + '" loading="lazy">';
      } else {
        html += '<div class="dn-result-img" style="background:rgba(168,85,247,.08)"></div>';
      }
      html += '<div class="dn-result-info">';
      html += '<span class="dn-result-title">' + title + '</span>';
      if (price) html += '<span class="dn-result-price">' + price + '</span>';
      html += '</div></a>';
    }
    html += '<div class="dn-search-results-footer">';
    html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="dn-drop-cta" style="text-decoration:none;display:inline-flex;">View all results for &ldquo;' + esc(query) + '&rdquo;</a>';
    html += '</div>';
    searchResults.innerHTML = html;
  }

  function fetchSuggestions(query) {
    if (!searchResults) return;
    searchResults.innerHTML = '<p class="dn-search-loading">Searching…</p>';
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
              '&resources[type]=product&resources[limit]=6';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(items, query);
      })
      .catch(function () {
        searchResults.innerHTML = '<p class="dn-search-no-results">Something went wrong. Try again.</p>';
      });
  }

  /* ── Search event listeners ──────────────────────────────────────────── */
  if (searchBtn)     searchBtn.addEventListener('click', openSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', function (e) {
    if (e.target === searchOverlay) closeSearch();
  });
  if (searchInput) searchInput.addEventListener('input', function () {
    var q = searchInput.value.trim();
    searchClear.classList.toggle('visible', searchInput.value.length > 0);
    clearTimeout(searchDebounce);
    if (q.length < 2) {
      showDefaultContent();
      return;
    }
    if (q === lastQuery) return;
    lastQuery = q;
    showResultsContent();
    searchDebounce = setTimeout(function () { fetchSuggestions(q); }, 260);
  });
  if (searchClear) searchClear.addEventListener('click', function () {
    searchInput.value = '';
    searchClear.classList.remove('visible');
    showDefaultContent();
    if (searchInput) searchInput.focus();
  });

})();
